import axios from "axios";
import Vue from "vue";
import Cookies from 'js-cookie'
import { defaultLang } from '@/i18n'
import i18n from '@/i18n'
// import NProgress from 'nprogress'
import { hasIn } from "lodash";
import router from "../../router/index";

import { Loading } from "element-ui";

//gq
// axios.defaults.baseURL = 'http://172.16.190.41:8081/'
// // lxh
// axios.defaults.baseURL = 'http://172.16.190.100:8081/'
// // hn
// axios.defaults.baseURL = 'http://172.16.110.244:8083/'
//hzm
// axios.defaults.baseURL = 'http://172.16.190.161:8082/'

// ceshi
// axios.defaults.baseURL = 'https://172.16.1.56:11022/'

let loadingInstance;
// axios.defaults.baseURL = "/api/";
axios.defaults.baseURL = process.env.VUE_APP_BASE_API;
// 请求头拦截
axios.interceptors.request.use((config) => {
    config.headers['Accept-Language'] = Cookies.get('language') || defaultLang
    let token = window.sessionStorage.getItem("token");
    config.headers.ClientId = "customer-app";
    config.headers['CLIENT-TOC'] = "Y";
    config.headers['tenant-id'] = window.sessionStorage.getItem('tenant-id') || '1'; // 需要修改
    if (token && !config.headers?.skipToken) {
        config.headers.Authorization = token;
    }
    const unLoadUrlArray = ['cmUser/message2/unReadCount', 'shopping/vehicle/queryAmountsPayable', 'shopping/vehicle/querySaveTime']
    // 自定义不需要 loading 的
    if (config.headers.noLoading) {
        delete config.headers.noLoading
        return config
    }
    // NProgress.start();
    if (!unLoadUrlArray.includes(config.url)) {
        loadingInstance = Loading.service({
            fullscreen: true,
            background: "rgba(0, 0, 0, 0.8)",
            text: i18n.t('loading'),
        });
    }
    // 对get请求的参数全部进行URL编码
    let url = config.url;
    if (config.method === 'get' && config.params) {
        let queryParts = [];
        Object.entries(config.params).forEach(([key, value]) => {
            //过滤 undefined  null
            if (value !== undefined && value !== null) {
                queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
            }
        });
        if (queryParts.length > 0) {
            url += (url.includes('?') ? '&' : '?') + queryParts.join('&');
        }
        config.params = {};
    }
    config.url = url;

    return config;
});
/* 响应拦截器 */
axios.interceptors.response.use(
    function (response) {
        if (
            response?.data?.code === 401 ||
            response?.data?.code === '401' ||
            response?.status === 401
        ) {
            window.sessionStorage.removeItem("token");
            if (router.currentRoute?.path !== "/login") {
                router.replace({ path: "/login" });
            }
        }
        if (
            loadingInstance &&
            response.config.url != "cmUser/message2/unReadCount"
        ) {
            loadingInstance.close();
        }
        return response;
    },
    function (error) {
        loadingInstance && loadingInstance.close();
        const status = error?.response?.status;
        const code = error?.response?.data?.code;
        if (status === 424 || code === 424 || code === '424') {
            window.sessionStorage.removeItem("token");
            if (router.currentRoute?.path !== "/login") {
                router.replace({ path: "/login" });
            }
        }
        return Promise.reject(error);
    }
);
Vue.prototype.$http = axios;

export default axios;
